import { api } from "../App";
import { SET_INITIAL_IMPORT_FILE, SET_INITIAL_IMPORT_LOADING } from "./types";


export const setInitialImport = (data, params) => async (dispatch) => {
  let success;
  try {
    dispatch({ type: SET_INITIAL_IMPORT_LOADING, payload: true });
    await api.post(`/initial_import`, data);
    success = true;
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_INITIAL_IMPORT_LOADING, payload: false });
    return success;
  }
}

export const setInitialImportFile = (file, parallels) => async (dispatch) => {
  try {
    const fd = new FormData();
    fd.append("file", file);
    const urlParams = `${parallels}=true`;
    const { data } = await api.post(`/initial_import?${urlParams}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    dispatch({ type: SET_INITIAL_IMPORT_FILE, payload: data });
  } catch (ERR) {
  }
};

export const createInitialImport = (data) => async (dispatch) => {
  let success;
  try {
    dispatch({ type: SET_INITIAL_IMPORT_LOADING, payload: true });
    await api.post(`/initial_import/data`, data);
    success = true;
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_INITIAL_IMPORT_LOADING, payload: false });
    return success;
  }
}
